
<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" pagination :max-items="this.itemsPerPage" :data="this.scheduledEmails">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1) }} - {{ this.scheduledEmails.length - this.currentPage * this.itemsPerPage > 0 ? this.currentPage * this.itemsPerPage : this.scheduledEmails.length }} of {{ this.scheduledEmails.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="this.itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="this.itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="this.itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="this.itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>



      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="companyName">Comany Name</vs-th>
        <vs-th sort-key="companyEmail">Email</vs-th>
        <vs-th sort-key="emailSubject">Mail Subject</vs-th>   
        <vs-th></vs-th>
        <vs-th></vs-th>
        <vs-th></vs-th>
        <vs-th></vs-th>
        <vs-th sort-key="deliveryStatus">Delivery Status</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <vs-avatar v-if="tr.company && tr.company.image" size="large" :src="tr.company.image" />
            <vs-avatar v-else size="large" src="https://lemonspaces.com/frontend/images/corporate-icon.png"  style="background:#FFFFFF;"/>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.company ? tr.company.name : ''}}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.email}}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.emailScheduleGroup.subject}}</p>
          </vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.deliveryStatus}}</p>
          </vs-td>
          <vs-td style="width: 160px;">
            <div class="vx-row">
              <i v-if="tr.deliveryStatus.toLowerCase() == 'sent'" class="material-icons" style="color: #219e21; font-size: 28px;">check_circle</i>
              <i v-else-if="tr.deliveryStatus.toLowerCase() == 'failed'" class="material-icons" style="color: rgb(236 30 30); font-size: 28px;">cancel</i>
              <i v-else class="material-icons" style="color: #d6b204; font-size: 28px;">access_alarms</i>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    data() {
      return {
        itemsPerPage: 15,
        columns : [
          {
            label: "Company Name",
            field: "companyName",
          },
          {
            label: "Email",
            field: "companyEmail",
          },
          {
            label: "Mail Subject",
            field: "emailSubject",
          },
          {
            label: "Delivery Status",
            field: "deliveryStatus",
          },
        ],
        stats: {},
        isMounted: false,
        profileData: {}
      }
    },
    async created() {
      this.$vs.loading({ text: 'Loading All Emails' })
      await this.loadAllScheduledEmails({
        storeName: 'scheduledEmails',
        url: `admin/scheduled-emails`,
        commitUrl: 'scheduledEmails/SET_EMAIL_SCHEDULES',
      })
      console.log(this.scheduledEmails)
      this.$vs.loading.close()
    },
    computed: {
      ...mapGetters({
        scheduledEmails: 'scheduledEmails/scheduledEmailsList',
        isLoading: 'scheduledEmails/isLoading',
        error: 'scheduledEmails/error',
      }),
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
    },
    mounted() {
      this.isMounted = true;
    },
    methods: {
      ...mapActions({
        loadAllScheduledEmails: 'get',
      }),
    },
  }
</script>

<style lang="scss">

.company-emails-popup-paragraph-container{

  margin-bottom: 5px;
  padding:0 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.company-emails-popup-paragraph-direct-wrapper{
  padding: 5px 10px; 
  border-bottom: 1px solid #ffdf48;
}
.company-emails-popup-paragraph-direct-wrapper span{
  padding-right: 15px;
  display: inline-block;
  font-weight: 500;
  color: rgb(0, 0, 0);
  // border-bottom: 1px solid #ffdf48;
}
.company-emails-popup-paragraph-direct-wrapper  p {
  display: inline-block;
  color: rgb(0, 0, 0);
  // border-bottom: 1px solid #ffdf48;

}
  #data-list-list-view {
    .vs-con-table {

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 8px 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
